/** CRM routes for per-team à la carte queue + catalog (Marketing, Finance, HR). */

export const TEAM_ALACARTE_DEPARTMENTS = ['Marketing', 'Finance', 'HR'];

export const TEAM_ALACARTE_SLUGS = {
  Marketing: 'marketing',
  Finance: 'finance',
  HR: 'hr',
};

/**
 * @param {'Marketing'|'Finance'|'HR'} department
 */
export function teamAlaCartePaths(department) {
  const slug = TEAM_ALACARTE_SLUGS[department];
  if (!slug) return { queue: '/crm', catalog: '/crm', slug: '' };
  return {
    slug,
    queue: `/crm/${slug}-alacarte-queue`,
    catalog: `/crm/${slug}-catalog`,
  };
}

/**
 * @param {string} pathname
 * @returns {'queue'|'catalog'|null}
 */
export function teamAlaCarteListKindFromPath(pathname) {
  if (pathname.includes('-catalog')) return 'catalog';
  if (pathname.includes('-alacarte-queue')) return 'queue';
  return null;
}

/** Display title for team queue list pages (per department). */
const TEAM_QUEUE_PAGE_TITLE = {
  Marketing: 'Client Marketing Bids',
  Finance: 'Client Finance Bids',
  HR: 'Client HR Bids',
};

/** Display title for team catalog list pages (per department). */
const TEAM_CATALOG_PAGE_TITLE = {
  Marketing: 'Marketing Services Catalog',
  Finance: 'Finance Services Catalog',
  HR: 'HR Services Catalog',
};

/**
 * @param {'Marketing'|'Finance'|'HR'} department
 */
export function getTeamQueuePageTitle(department) {
  return TEAM_QUEUE_PAGE_TITLE[department] || `Client ${department} Bids`;
}

/**
 * @param {'Marketing'|'Finance'|'HR'} department
 */
export function getTeamCatalogPageTitle(department) {
  return TEAM_CATALOG_PAGE_TITLE[department] || `${department} Services Catalog`;
}
